import { render, staticRenderFns } from "./FreightRejectConfirm.vue?vue&type=template&id=2d235e61&"
import script from "./FreightRejectConfirm.vue?vue&type=script&lang=js&"
export * from "./FreightRejectConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports